import {
  usePostAuthSendCode,
  usePostAuthVerifyCode,
  usePostAuthLogin,
  usePostUsersLogout,
} from '@/types/origin-point-engine'
import { logger } from '@/lib/logger'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { type VerifyCodeResponse } from '../types/type'
import { showErrorData } from '@/lib/toast'

export const useAuth = () => {
  const { reset } = useAuthStore().auth


  const authVerifyCodeMutationAsync = usePostAuthVerifyCode({
    mutation: {
      onSuccess(data: unknown) {
        const response = data as VerifyCodeResponse
        logger.info('用户验证成功')
        logger.debug('New Token:', response.data.accessToken)
      },
      onError(error) {
        logger.error(`verify code error:${error}`)
        showErrorData('验证错误：', error)
      },
    },
  }).mutateAsync

  const { mutateAsync: authSendCodeMutationAsync, status: authSendCodeStatus } =
    usePostAuthSendCode({
      mutation: {
        onSuccess() {
          logger.info('用户发送验证码成功')
        },
        onError(error) {
          logger.error(`用户发送验证码失败:${error}`)
        },
      },
    })

  const authLogoutMutationAsync = usePostUsersLogout({
    mutation: {
      onSuccess() {
        reset()
        logger.info('用户退出登录成功')
      },
      onError(error) {
        logger.error(`用户退出登录失败:${error}`)
      },
    },
  }).mutateAsync

  const authLoginMutationAsync = usePostAuthLogin({
    mutation: {
      onSuccess() {
        logger.info('用户登录成功')
      },
      onError(error) {
        logger.error(`用户登录失败:${error}`)
      },
    },
  }).mutateAsync

  return {
    authVerifyCodeMutationAsync,
    authSendCodeMutationAsync,
    authSendCodeStatus,
    authLogoutMutationAsync,
    authLoginMutationAsync,
  }
}
